var _rect, _ellipse, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCautionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#FDCA3F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6836,
    cy: 18.9984,
    rx: 7.26316,
    ry: 8.8421,
    fill: "#080708"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 8.27344C18.5913 8.27295 17.1965 8.55002 15.895 9.08883C14.5936 9.62763 13.4111 10.4176 12.4151 11.4136C11.4191 12.4096 10.6291 13.5921 10.0903 14.8936C9.55148 16.195 9.27441 17.5899 9.2749 18.9984C9.27441 20.407 9.55148 21.8019 10.0903 23.1033C10.6291 24.4047 11.4191 25.5873 12.4151 26.5833C13.4111 27.5793 14.5936 28.3692 15.895 28.9081C17.1965 29.4469 18.5913 29.7239 19.9999 29.7234C21.4085 29.7239 22.8033 29.4469 24.1048 28.9081C25.4062 28.3692 26.5887 27.5793 27.5847 26.5833C28.5807 25.5873 29.3707 24.4047 29.9095 23.1033C30.4483 21.8019 30.7254 20.407 30.7249 18.9984C30.7254 17.5899 30.4483 16.195 29.9095 14.8936C29.3707 13.5921 28.5807 12.4096 27.5847 11.4136C26.5887 10.4176 25.4062 9.62763 24.1048 9.08883C22.8033 8.55002 21.4085 8.27295 19.9999 8.27344ZM19.9999 26.7234C19.6792 26.7242 19.3655 26.6297 19.0985 26.452C18.8315 26.2743 18.6233 26.0213 18.5002 25.7251C18.3771 25.429 18.3447 25.1029 18.4071 24.7883C18.4695 24.4737 18.6239 24.1847 18.8506 23.9579C19.0774 23.7311 19.3664 23.5768 19.681 23.5144C19.9956 23.452 20.3217 23.4844 20.6178 23.6075C20.914 23.7306 21.167 23.9388 21.3447 24.2058C21.5224 24.4727 21.6169 24.7865 21.6162 25.1072C21.6152 25.5355 21.4446 25.9461 21.1417 26.249C20.8388 26.5518 20.4283 26.7224 19.9999 26.7234ZM21.9612 13.3734L21.3499 21.6234C21.3461 21.6805 21.3207 21.7339 21.2789 21.7729C21.2371 21.8119 21.1821 21.8336 21.1249 21.8334H18.8749C18.8177 21.8336 18.7627 21.8119 18.7209 21.7729C18.6791 21.7339 18.6537 21.6805 18.6499 21.6234L18.0387 13.3734C18.0221 13.1057 18.0605 12.8374 18.1516 12.585C18.2427 12.3327 18.3844 12.1017 18.5682 11.9062C18.7519 11.7108 18.9737 11.555 19.22 11.4485C19.4662 11.342 19.7316 11.2871 19.9999 11.2871C20.2682 11.2871 20.5336 11.342 20.7798 11.4485C21.0261 11.555 21.2479 11.7108 21.4316 11.9062C21.6154 12.1017 21.7571 12.3327 21.8482 12.585C21.9393 12.8374 21.9777 13.1057 21.9612 13.3734Z",
    fill: "#FDCA3F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIcon);
export default __webpack_public_path__ + "static/media/cautionIcon.f47ed8c2de5e0389657f69825ab0deb6.svg";
export { ForwardRef as ReactComponent };